module.exports = __webpack_public_path__ + "img/IMG_8771.cad1c90b.jpg";